module.exports = __webpack_public_path__ + "img/about-page-left.cc1c9b3b.png";